import { connect } from 'react-redux';
import { FlatPhase } from '../components/flat_phase';
function mapStateToProps(state) {
  var MVKData = state.MVKData,
    _state$MVKState = state.MVKState,
    phase = _state$MVKState.phase,
    flat = _state$MVKState.flat;
  return {
    currentPhase: phase,
    flat: MVKData.offers.find(function (offer) {
      return offer.id === flat.id;
    })
  };
}
export var FlatPhaseContainer = connect(mapStateToProps)(FlatPhase);